import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
    private readonly keycloakService: KeycloakService,
  ) { }

  public updateCompany(payload: any) {
    return this.http.put<any>(environment.baseURL + '/companies/update', payload)
      .pipe(map(res => res.data));
  }

  public regenerateApiKey() {
    return this.http.put<any>(environment.baseURL + '/companies/api-key/regenerate', {})
      .pipe(map(res => res.data));
  }

  public getZone() {
    return this.http.get<any>(environment.baseURL + '/companies/zone')
      .pipe(map(res => res.data));
  }

  public getSettings() {
    return this.http.get<any>(environment.baseURL + '/companies/settings')
      .pipe(map(res => res.data));
  }

  public updateSettings(id: string, payload: any) {
    return this.http.put<any>(environment.baseURL + `/companies/settings/${id}`, payload)
      .pipe(map(res => res.data));
  }
}
